export const NOTIFICATION_ID_TO_STEP: Record<string, string> = {
  "onboarding-week1-day1-welcome": "week1-day1",
  "onboarding-week1-day1-did-you-know": "week1-day1",
  "onboarding-week1-day2-start-small": "week1-day2",
  "onboarding-week1-day2-not-sure": "week1-day2",
  "onboarding-week1-day3-win-big": "week1-day3",
  "onboarding-week1-day3-did-you-know": "week1-day3",
  "onboarding-week1-day4-fourth-time-here": "week1-day4",
  "onboarding-week1-day4-first-time-review": "week1-day4",
  "onboarding-week1-day5-logged-five-times": "week1-day5",
  "onboarding-week2-did-you-know": "week2",
  "onboarding-week3-did-you-know": "week3",
  "onboarding-week3-get-hang-of-it": "week3",
  "onboarding-week3-routine": "week3",
  "onboarding-week4-grow-your-business": "week4",
};

export function getNextOnboardingStep(notifications): string | null {
  const next = notifications.find((n) => NOTIFICATION_ID_TO_STEP[n.id]);
  return next ? NOTIFICATION_ID_TO_STEP[next.id] : null;
}
